import { defineMessages } from 'react-intl';
import { intl } from 'hellospa/components/hs-intl-provider';
import { OperatorDropdown } from './types';

/* eslint-disable import/prefer-default-export */


const messages = defineMessages({
  satisfiesCustomRegex: {
    id: '',
    description: `dropdown string, sets the rule for text,
    eg: user(sender) can set the custom regex for a input field to match the inputted value by signer, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'satisfies custom regex',
  },
  is: {
    id: '',
    description: `dropdown string, sets the rule for checkbox, text, radio button or dropdown fields,
    eg: user(sender) can set the inputted value by signer to be equal to some string, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'is',
  },
  isNot: {
    id: '',
    description: `dropdown string, sets the rule for checkbox, text, radio button or dropdown fields,
    eg: user(sender) can set the inputted value by signer to be not equal to some string, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'is not',
  },
  isChecked: {
    id: '',
    description: `dropdown string, sets the rule for checkbox,
    eg: user(sender) can set the rule for either checked or uncheck of checkbox, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'is checked',
  },
  isNotChecked: {
    id: '',
    description: `dropdown string, sets the rule for checkbox,
    eg: user(sender) can set the rule for either checked or uncheck of checkbox, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'is not checked',
  },
  isOneOfThese: {
    id: '',
    description: `dropdown string, sets the rule for dropdown fields,
    eg: user(sender) can add dropdown options and set a rule if signer selects one of these options, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'is one of these',
  },
  isNoneOfThese: {
    id: '',
    description: `dropdown string, sets the rule for dropdown fields,
    eg: user(sender) can add dropdown options and set a rule if signer selects one of these options, then it will show or hide another input field for signer to take an action`,
    defaultMessage: 'is none of these',
  },
});

// human readable operator text
export const operatorsForFields: OperatorDropdown = {
  text: {
    match: intl.formatMessage(messages.satisfiesCustomRegex),
    is: intl.formatMessage(messages.is),
    not: intl.formatMessage(messages.isNot),
  },
  checkbox: {
    is: intl.formatMessage(messages.isChecked),
    not: intl.formatMessage(messages.isNotChecked),
  },
  radiobutton: {
    is: intl.formatMessage(messages.is),
    not: intl.formatMessage(messages.isNot),
    any: intl.formatMessage(messages.isOneOfThese),
    none: intl.formatMessage(messages.isNoneOfThese),
  },
  dropdown: {
    is: intl.formatMessage(messages.is),
    not: intl.formatMessage(messages.isNot),
    any: intl.formatMessage(messages.isOneOfThese),
    none: intl.formatMessage(messages.isNoneOfThese),
  },
};
